import { isVideoArticlePage } from '../../utils/aem-utils';
import { $heroPlaylist, VIDEO_PLAYER_STATUS } from '../video-player/constants';
import { getLabel } from '../../labels/labelling-service';
import { VIDEO_TITLE_MODIFIER } from '../hero-disclaimer/constants';

import { appendCloseButton, disableStickyElement, getVideoPlayer, removeCloseButton } from './helpers';
import { stickyHeroPlayerState } from './state';
import { $player } from './constants';
import { stickyHeroPlayerDisclaimer } from './sticky-hero-player';

export const initVideoPlayerListeners = (players) => {
  const playerInstance = getVideoPlayer(players);
  if (!playerInstance) {
    return;
  }

  playerInstance.on(VIDEO_PLAYER_STATUS.AD_PLAY, () => {
    if ($player.dataset.videotitle && !isVideoArticlePage()) {
      stickyHeroPlayerDisclaimer.render({ disclaimerTitle: getLabel('disclaimer.preroll') });
    }
  });

  playerInstance.on(VIDEO_PLAYER_STATUS.COMPLETE, () => {
    if (!$heroPlaylist) {
      stickyHeroPlayerState.setState('isVideoFinished', true);
      stickyHeroPlayerState.setState('hasUserRejectedSticky', true);
      disableStickyElement();
    }
  });

  playerInstance.on(VIDEO_PLAYER_STATUS.PLAY, () => {
    if (!isVideoArticlePage() && !stickyHeroPlayerState.getState('hasUserRejectedSticky')) {
      appendCloseButton(players);
    }
    if ($player.dataset.videotitle && !isVideoArticlePage()) {
      stickyHeroPlayerDisclaimer.render({
        disclaimerTitle: $player.dataset.videotitle,
        disclaimerClassNameModifiers: [VIDEO_TITLE_MODIFIER],
      });
    }
  });

  playerInstance.on(VIDEO_PLAYER_STATUS.AD_COMPLETE, () => {
    stickyHeroPlayerDisclaimer.dispose();
  });

  playerInstance.on(VIDEO_PLAYER_STATUS.REPLAY_CLICK, () => {
    stickyHeroPlayerState.setState('hasUserRejectedSticky', false);
    stickyHeroPlayerState.setState('isVideoFinished', false);
    stickyHeroPlayerDisclaimer.dispose();
  });

  playerInstance.on(VIDEO_PLAYER_STATUS.PAUSE, () => {
    removeCloseButton();
  });
};
